import { topTicker } from '@/mocks/gossipData';

export default function TopTicker() {
  const items = [...topTicker, ...topTicker];
  return (
    <div className="flex w-full items-stretch overflow-hidden bg-foreground-950 text-background-50">
      <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-600 px-3 py-2 text-background-50 md:px-4">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
        </span>
        <span className="whitespace-nowrap text-xs font-bold tracking-wide md:text-sm">实时动态</span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden">
        <div className="animate-ticker flex w-max items-center whitespace-nowrap py-2">
          {items.map((it, idx) => (
            <span key={`${it.id}-${idx}`} className="inline-flex items-center text-xs md:text-sm">
              <span className="mx-4 text-background-500">{it.time}</span>
              <span
                className={
                  it.kind === '实锤'
                    ? 'text-accent-400'
                    : it.kind === '反转'
                      ? 'text-accent-300'
                      : it.kind === '辟谣'
                        ? 'text-background-300'
                        : 'text-primary-300'
                }
              >
                [{it.kind}]
              </span>
              <span className="ml-1.5 cursor-pointer text-background-100 transition-colors hover:text-background-50">
                {it.text}
              </span>
              <i className="ri-arrow-right-line mx-5 text-background-600" />
            </span>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="hidden shrink-0 cursor-pointer items-center gap-1.5 border-l border-background-800 px-4 text-xs text-background-200 transition-colors hover:text-background-50 md:flex"
      >
        <i className="ri-time-line text-sm" />
        往期动态
      </button>
    </div>
  );
}